module.exports = __webpack_public_path__ + "img/NO_EXTRAS.a0a7ba50.jpg";